export const ellipsizeByCharCount = (text: string, maxCharCount: number) => {
  if (text.length > maxCharCount) {
    return text.substring(0, maxCharCount - 3) + '...';
  }
  return text;
};

/**
 * Truncate a string for activity-feed tag display.
 * Strings of 24 characters or fewer are returned as-is.
 * Longer strings are clipped so the total visible length (text + ellipsis) is 24.
 *
 * Used by Tag.web and TagsCollection.web so the threshold is defined once.
 */
export const truncateForActivityFeed = (str: string): string => {
  const MAX = 24;
  if (str.length <= MAX) return str;
  return str.slice(0, MAX - 3) + '...';
};
